import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/* Motion-wrapped tag map — static references for stable component identity */
const MOTION_TAGS = {
    div: motion.div,
    section: motion.section,
    article: motion.article,
    span: motion.span,
    li: motion.li,
    ul: motion.ul,
    nav: motion.nav,
    a: motion.a,
    header: motion.header,
    footer: motion.footer,
    aside: motion.aside,
    main: motion.main,
};

/**
 * Subtle fade-up-on-scroll wrapper.
 * Respects prefers-reduced-motion via framer-motion's useReducedMotion hook.
 */
export const FadeUp = ({
    children,
    delay = 0,
    duration = 0.45,
    y = 18,
    className = "",
    as = "div",
    once = true,
    ...rest
}) => {
    const reduce = useReducedMotion();

    const initial = reduce ? { opacity: 1, y: 0 } : { opacity: 0, y };
    const whileInView = { opacity: 1, y: 0 };

    const MotionTag = MOTION_TAGS[as] || motion.div;

    return (
        <MotionTag
            initial={initial}
            whileInView={whileInView}
            viewport={{ once, amount: 0.18 }}
            transition={{
                duration: reduce ? 0 : duration,
                delay: reduce ? 0 : delay,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
            {...rest}
        >
            {children}
        </MotionTag>
    );
};

export default FadeUp;
